<div class="page-holder">

    <div class="title-holder">
        <div class="center-content">
            <div class="header-image">
                <img src="/assets/images/create-card-top.svg" alt="Złóż wniosek o kartę ZGrane Grono">
            </div>
            <div class="header-text">Program osłonowy „ZGrane Grono” powstał z myślą o wzmacnianiu lokalnej wspólnoty i
                budowaniu więzi między mieszkańcami Zielonej Góry. Jego głównym celem jest wspieranie różnych grup
                społecznych poprzez umożliwienie im korzystania z atrakcyjnych zniżek, ofert i wydarzeń, które sprzyjają
                aktywnemu uczestnictwu w życiu miasta.</div>

        </div>
    </div>
    <div class="statistics-holder">
        <div class="center-content two-cols">
            <div class="statistic-item left-align">
                <h3>Cel programu</h3>
                <b>Poprawa warunków życia mieszkańców miasta:</b>
                <ul>
                    <li>podejmowanie działań mających na celu wsparcie rodzin,</li>
                    <li>zwiększenie dostępności i zachęcenie do udziału w wydarzeniach społecznych, kulturalnych,
                        sportowych i rekreacyjnych,</li>
                    <li>wzmocnienie poczucia tożsamości lokalnej mieszkańców,</li>
                    <li>dotarcie z ofertą Programu „ZGrane Grono” do osób uprawnionych do udziału, które dotychczas nie
                        korzystały z dostępnych form wsparcia.</li>
                </ul>
                <p>ZGrane Grono to nie tylko Program zniżek, to społeczna idea, która łączy pokolenia, zachęca do
                    wspólnego działania i pokazuje,  że Zielona Góra to miasto, w którym warto żyć.
                </p>

                <h3>Aplikacja</h3>
                <p>Aplikacja „ZGrane Grono” - szybka, niezawodna i działająca nawet bez internetu. Stawiamy na
                    mobilność, zachęcając użytkowników do korzystania z aplikacji mobilnej.</p>
            </div>
            <div class="statistic-item left-align">
                <h3>Dla kogo</h3>
                <b>Karta „ZGrane Grono” </b> przysługuje mieszkańcom Miasta Zielona Góra, w szczególności:
                <ul>
                    <li>osobom objętym wsparciem przez Miejski Ośrodek Pomocy Społecznej w Zielonej Górze oraz ich
                        dzieciom,</li>
                    <li>dzieciom będącym pod opieką zawodowych rodzin zastępczych, instytucjonalnej bądź rodzinnej
                        pieczy zastępczej oraz rodzinnych domach dziecka,</li>
                    <li>osobom posiadającym orzeczenie o niepełnosprawności/o stopniu niepełnosprawności,</li>
                    <li>emerytom i rencistom,</li>
                    <li>dzieciom do ukończenia 18. roku życia, a w przypadku kontynuowania nauki do jej zakończenia, nie
                        dłużej jednak niż do ukończenia 26. roku życia,</li>
                    <li>studentom Uniwersytetu Zielonogórskiego do ukończenia 26. roku życia</li>
                </ul>

                <h3>Karty</h3>
                <p>Karta „ZGrane Grono”, wydawana jest bezpłatnie na 3 lata. Występuje w formie tradycyjnej i
                    elektronicznej.</p>
            </div>
        </div>
    </div>



    <div class="info-text-holder">
        <div class="center-content two-cols">
            <div>
                <h2 class="title uppercase">W celu otrzymania Karty należy:</h2>

                <div class="bottom-image-holder">
                    <img src="/assets/images/create-card-bottom.png" alt="Dołącz już teraz">
                </div>

                <div class="button-holder">
                    <button class="custom-button" (click)="goToRegister()"> Dołącz już teraz</button>
                </div>
            </div>
            <div>
                <ul>
                    <li><b>Zarejestrować się</b> w Programie poprzez dedykowany portal www.zgranegrono.pl i w kolejnym
                        etapie wypełnić wniosek w formie elektronicznej albo wypełnić wniosek w formie papierowej i
                        złożyć go osobiście w biurze Programu.</li>
                    <li><b>Wnioski dostępne są:</b>
                        <ul>
                            <li>na stronie internetowej www.zgranegrono.pl,</li>
                            <li>w Biurze Obsługi Programu. Stary Rynek 1,</li>
                            <li>w recepcji Centrum Rekreacyjno - Sportowego.</li>
                        </ul>
                    </li>
                    <li><b>Weryfikacja spełnienia warunków</b> odbywa się w biurze Programu:
                        <ul>
                            <li>
                        w przypadku osób zamieszkałych na terenie miasta, dzieci i młodzieży-przeprowadzenie weryfikacji odbywa się przez realizatora Programu
                        </li><li>
                        
                        w przypadku osób posiadających orzeczenie o
                        niepełnosprawności/o stopniu niepełnosprawności 
                        </li><li>
                        przedstawieniu do wglądu legitymacji  o
                        niepełnosprawności/o stopniu niepełnosprawności oraz oświadczenia o miejscu zamieszkania
                        </li><li>
                        w przypadku emeryta bądź rencisty – przedstawieniu do wglądu legitymacji emeryta/ rencisty oraz dokumentu, z którego wynika, że jego miejscem zamieszkania jest miasto, tj. pierwszej strony PIT 40A
                        </li>
                        </ul>
                    <li><b>Karta wydawana jest na wniosek:</b>
                        <ul>
                            <li>osoby, która ubiega się o przyznanie karty,</li>
                            <li>opiekuna prawnego dzieci osób, do ukończenia przez nie 18 roku życia.</li>
                        </ul>
                </ul>

            </div>
        </div>
    </div>

</div>